import {
  defaultBase,
  defaultSettings,
} from '@components/Widgets/_contentItems/_baseTemplate'

export const defaultStyling = {
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontWeight: '400',
  color: 'rgb(24,23,26)',
  textAlign: 'center',
}

export default {
  id: '64534345',
  type: 'text',
  category: 'basic',
  ...defaultBase,
  content: {
    text: 'I am some text. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  settings: {
    ...defaultSettings,
  },
  // Ex. maxLetters: 0,
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: { ...defaultStyling },
}
